module.exports = __webpack_public_path__ + "img/主页图片4-tuya.a99511cf.png";